import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const MANUALS_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_MANUALS_MGMT,
  STEP_TWO: `${ROUTES.ADMIN_MANUALS_MGMT}/stepTwo`,
  STEP_THREE: `${ROUTES.ADMIN_MANUALS_MGMT}/stepThree`,
};

export const STATE_IDENTIFIER = {
  STEP_ONE: "stepOne",
  STEP_TWO: "stepTwo",
  STEP_THREE: "stepThree",
  MANUALS_SECTIONS_TABLE: "manualsSections",
  SECTION_DETAIL: "sectionDetail",
  ATTACHMENTS: "attachments",
  ATTACHMENT: "attachment",
  ATTACHMENT_ROLES: "attachmentRoles",
  SELECTED_ROLES: "selectedRoles",
  REQUEST_STATE: "requestState",
  ROLES: "roles",
  ADDED_ROLES: "addedRoles",
  REMOVED_ROLES: "removedRoles",
  TOTAL_ROLES: "totalRoles",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
